import _ from 'lodash'
import { createSelector } from 'reselect'

import { getMedicationFormsSingleSelector } from 'services/medicationForms/single/selectors'

import { RootState } from 'core/reducers'

import { Review, ReviewHistoryData } from '../models'

export const getReviewsSelector = (state: RootState) => state.reviews

export const getReviewsListSelector = createSelector(
  [getReviewsSelector],
  (state) => state.list.data,
)

interface GetCriteriaProps {
  medicationFormId?: number
  membershipId?: number
}

export const getListCriteria = ({ medicationFormId, membershipId }: GetCriteriaProps) => {
  const criteria = []

  if (medicationFormId) {
    criteria.push({
      field: 'medicationForm',
      value: medicationFormId,
    })
  }

  if (membershipId) {
    criteria.push({
      field: 'author',
      value: membershipId,
    })
  }

  return criteria
}

export const getReviewHistoryData = createSelector(
  [getMedicationFormsSingleSelector, getReviewsListSelector],
  (medicationForm, reviewsList: Review[]): ReviewHistoryData[] | null => {
    if (!medicationForm || !reviewsList?.length) {
      return null
    }

    return _.map(reviewsList, ({
      author,
      createdAt,
      endMedicationDate,
      medicationForm: reviewMedicationForm,
      medicationReturnedDate,
      nextReviewDate,
      notes,
      signatures,
      type,
      updatedAt,
    }, index) => {
      const { child } = reviewMedicationForm
      const isAuthorKeyPerson = child?.keyWorkers?.some(({ id }) => id === author?.id)

      const nextRecord = reviewsList[index + 1]

      let oldEndMedicationDate: Date | string
      let oldMedicationReturnDate: Date | string
      let oldNextReviewDate: Date | string

      if (nextRecord) {
        oldEndMedicationDate = nextRecord?.endMedicationDate || nextRecord?.nextReviewDate
        oldMedicationReturnDate = nextRecord?.medicationReturnedDate || nextRecord?.nextReviewDate
        oldNextReviewDate = nextRecord?.nextReviewDate
      } else {
        oldEndMedicationDate = medicationForm.initialEndDate as Date
        oldMedicationReturnDate = medicationForm.reviewDate as Date
        oldNextReviewDate = medicationForm.reviewDate as Date
      }

      return {
        author,
        createdAt,
        endMedicationDate: {
          newValue: endMedicationDate,
          oldValue: oldEndMedicationDate,
        },
        isAuthorKeyPerson,
        medicationForm,
        medicationReturnedDate: {
          newValue: medicationReturnedDate,
          oldValue: oldMedicationReturnDate,
        },
        nextReviewDate: {
          newValue: nextReviewDate,
          oldValue: oldNextReviewDate,
        },
        notes,
        signatures,
        type,
        updatedAt,
      } satisfies ReviewHistoryData
    })
  },
)
